import type { LeagueMatchDetailUrlState, LeagueMatchTab } from './types';

const tabs: readonly LeagueMatchTab[] = ['overview', 'lineup', 'events', 'team-stats', 'player-stats', 'build-up', 'analysis'];
const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const positiveInteger = (value: string | null): number | null => {
  if (!value || !/^\d+$/.test(value)) return null;
  const parsed = Number(value);
  return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : null;
};

export const parseLeagueMatchDetailUrl = (search: URLSearchParams): LeagueMatchDetailUrlState => {
  const rawSession = search.get('chatSession');
  const validChatSession = rawSession && uuidPattern.test(rawSession) ? rawSession : null;
  const playerValues = search.getAll('player');
  const rawPlayer = playerValues.length === 1 ? playerValues[0] : null;
  const player = rawPlayer && uuidPattern.test(rawPlayer) ? rawPlayer : null;
  const invalidPlayer = playerValues.length > 0 && player === null;
  const rawTab = search.get('tab') as LeagueMatchTab | null;
  const explicitTab = rawTab && tabs.includes(rawTab) ? rawTab : null;
  const tab = explicitTab ?? (validChatSession ? 'analysis' : 'overview');
  return {
    tab,
    season: positiveInteger(search.get('season')),
    player,
    invalidPlayer,
    chatSession: tab === 'analysis' ? validChatSession : null,
  };
};

export const serializeLeagueMatchDetailUrl = (state: LeagueMatchDetailUrlState): URLSearchParams => {
  const params = new URLSearchParams();
  if (state.season && Number.isSafeInteger(state.season) && state.season > 0) params.set('season', String(state.season));
  if (state.player && uuidPattern.test(state.player)) params.set('player', state.player);
  if (state.tab !== 'overview' && tabs.includes(state.tab)) params.set('tab', state.tab);
  if (state.tab === 'analysis' && state.chatSession && uuidPattern.test(state.chatSession)) {
    params.set('chatSession', state.chatSession);
  }
  return params;
};
